/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type PermissionsWatchListsFilter = {
    /**
     * Number of results to return.
     */
    limit?: number;
    /**
     * Which field to use when ordering the results. Available fields: `id`
     */
    ordering?: string;
}
export const EmptyPermissionsWatchListsFilter: PermissionsWatchListsFilter = {
    limit: 20,
    ordering: '-id',
}